(() => {
  if (customElements.get('wolf-set-builder-card')) return;

  class WolfSetBuilderCard extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.formElement = this.querySelector('product-form');
      this.quantity = this.querySelector('[name="quantity"]');
      this.idInput = this.querySelector('[name="id"]');
      if (!this.formElement || !this.quantity || !this.idInput) return;
      this.purchasing = this.querySelector('wolf-purchasing');
      const variants = this.querySelector('[data-wolf-card-variants]');
      this.variants = variants ? JSON.parse(variants.textContent) : [];
      const options = { signal: this.events.signal };
      // Capture before the older, document-wide swatch handler runs.
      this.addEventListener('click', (event) => this.selectSwatch(event), { ...options, capture: true });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') this.selectSwatch(event);
      }, options);
      if (!this.purchasing) this.syncLegacyVariant(this.idInput.value);
    }

    disconnectedCallback() { this.events?.abort(); }

    selectSwatch(event) {
      const swatch = event.target.closest('[data-wolf-variant-id]');
      if (!swatch || !this.contains(swatch)) return;
      event.preventDefault();
      event.stopPropagation();
      const variantId = swatch.dataset.wolfVariantId;
      this.querySelectorAll('.media.variant').forEach((media) => {
        media.classList.toggle('visible', media.classList.contains(`variantId-${variantId}`));
      });
      this.querySelectorAll('.variant-swatch').forEach((label) => {
        label.classList.toggle('visible', label === swatch);
        label.setAttribute('aria-pressed', String(label === swatch));
      });
      this.querySelectorAll('.card__heading a, [data-more-colors]').forEach((link) => {
        link.href = swatch.dataset.wolfVariantUrl;
      });
      this.formElement.handleErrorMessage?.();
      if (this.purchasing) {
        this.purchasing.dataset.selectedVariant = variantId;
        this.dispatchEvent(new CustomEvent('wolf:card-variant-change', { detail: { variantId } }));
      } else {
        this.syncLegacyVariant(variantId);
        const price = this.querySelector('.price');
        price?.classList.toggle('price--on-sale', Boolean(swatch.dataset.wolfVariantCompare));
        price?.querySelectorAll('.price__regular .price-item, .price-item--sale').forEach((node) => {
          node.textContent = swatch.dataset.wolfVariantPrice;
        });
        const compare = price?.querySelector('.price__sale .price-item--regular');
        if (compare) compare.textContent = swatch.dataset.wolfVariantCompare;
      }
    }

    syncLegacyVariant(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      const button = this.querySelector('[type="submit"]');
      this.idInput.value = variant?.id || '';
      this.idInput.disabled = !variant?.available;
      button.disabled = !variant?.available;
      button.querySelector('span').textContent = variant?.available ? 'Add to bag' : 'Sold out';
      this.querySelectorAll('.card__badge').forEach((badge) => { badge.hidden = Boolean(variant?.available); });
      const rule = variant?.quantityRule || {};
      this.quantity.min = rule.min || 1;
      this.quantity.step = rule.increment || 1;
      if (rule.max) this.quantity.max = rule.max;
      else this.quantity.removeAttribute('max');
      const value = Number(this.quantity.value);
      const minimum = Number(this.quantity.min);
      const step = Number(this.quantity.step);
      let quantity = Number.isSafeInteger(value) ? Math.max(minimum, value) : minimum;
      quantity = minimum + Math.ceil((quantity - minimum) / step) * step;
      if (rule.max) quantity = Math.min(quantity, rule.max);
      this.quantity.value = quantity;
      this.querySelector('quantity-input')?.validateQtyRules?.();
    }
  }

  customElements.define('wolf-set-builder-card', WolfSetBuilderCard);
})();
